import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import HelptextTooltip from 'common/components/helptext-tooltip';
import {nt, t} from 'common/utils/translation-util';
import './index.scss';

// NOTE: this component uses window.settings stores.  When using this component,
// make sure that the appropriate store variables are available by including
// reports/dashboard_urls.js into a script tag on the template.
export default class DashboardActionsIconBox extends React.Component {
  static propTypes = {
    dashboard: PropTypes.object.isRequired,
  };

  render() {
    const canSchedule = window.settings.user.canCreateSchedules;
    const isDefault = this.props.dashboard.default;
    const canEmail = canSchedule && !isDefault;

    const numEmailSchedules = window.emailSchedulesCount;
    const showEmail = numEmailSchedules > 0;
    const showStoryboard = window.settings.dashboard.usedInAStoryboard;
    const {dashboard} = this.props;
    return (
      <ul className={'DashboardActionsIconBox'}>
        <li className={'DashboardActionsIconBox-link'}>
          <HelptextTooltip showIcon={false}>
            {this.props.dashboard.public ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: t(
                    'The fullscreen link to this dashboard is accessible to ' +
                      '<strong>anyone with the link</strong>.',
                  ),
                }}
              />
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t(
                    'The fullscreen link to this dashboard is accessible to ' +
                      '<strong>Atrius users only</strong>.',
                  ),
                }}
              />
            )}
          </HelptextTooltip>
          <SvgSymbol name={'link'} />
        </li>

        {showEmail ? (
          <li className={'DashboardActionsIconBox-email'}>
            <HelptextTooltip showIcon={false}>
              {t('This dashboard is used in ')}
              <strong>
                {nt(
                  '%(count)s email schedule.',
                  '%(count)s email schedules.',
                  numEmailSchedules,
                  {
                    count: numEmailSchedules,
                  },
                )}
              </strong>
              {canEmail ? (
                <strong>
                  <br />
                  <br />
                  <a
                    className={'emailDelivery'}
                    data-dashboard-id={dashboard.id}
                    data-dashboard-name={dashboard.name}
                    href={'#'}>
                    {t('Email Dashboard')}
                  </a>
                </strong>
              ) : null}
            </HelptextTooltip>
            <SvgSymbol name={'schedule-email'} />
          </li>
        ) : null}

        {showStoryboard ? (
          <li className={'DashboardActionsIconBox-storyboard'}>
            <HelptextTooltip showIcon={false}>
              {t('This dashboard is used in one or more storyboards.')}
            </HelptextTooltip>
            <SvgSymbol name={'storyboard'} />
          </li>
        ) : null}

        {this.props.dashboard.limitedPermissions ? (
          <li className={'DashboardActionsIconBox-limited'}>
            <HelptextTooltip showIcon={false}>
              {t('This dashboard has limited view or edit access.')}
            </HelptextTooltip>
            <SvgSymbol name={'private'} />
          </li>
        ) : null}

        <li className={'DashboardActionsIconBox-moreInfo'}>
          <HelptextTooltip showIcon={false}>
            <strong>{t('Scope')}</strong>
            {':'} {dashboard.category}
            <br />
            <strong>{t('Author')}</strong>
            {':'} {dashboard.author.name}
            <br />
            <strong>{t('Organization')}</strong>
            {':'} {dashboard.organization.name}
            <br />
            <strong>{t('Last Updated')}</strong>
            {':'} {t('%(time)s ago', {time: dashboard.lastUpdateDateDiff})}
            {dashboard.lastEditor ? (
              <React.Fragment>
                {t(' by %(name)s', {name: dashboard.lastEditor.name})}
              </React.Fragment>
            ) : null}
          </HelptextTooltip>
          <SvgSymbol name={'more-info'} style={{width: '20px'}} />
        </li>
      </ul>
    );
  }
}
